/*
 * Groups
 * 
 * @author: Elton Jain
 */
/* global define, require */

define('modules/TV',[
    'jquery',
    'UI',
    'JSTemplate', // Template engine
    'Config'
], function($, UI, template, Config) {
    'use strict';
    var tvPageData = {},
        $elPageTVWrapper = $('#pagePTTV'),
        langs = Config.get('lang'),
        CURRENT_ROUTE = Config.get('page.route');


    function init () {
        // First page or subsequent page call
        // Open specific list based on page route
        bindEvents();

        // Primary page
        if(CURRENT_ROUTE === 'tv.categories') {
            CategoryPageCall();
        } else if(CURRENT_ROUTE === 'experts') {
            ExpertsPage();
        } else {
            firstPageCall();
        }

        // Sub page
        if(CURRENT_ROUTE === 'tv.videos') {
            var type = Config.get('page.urlParams.type') || 'recommended';
            if(type !== '') {
                showTVListPage(langs[type+'_videos'], type);
            }
        }
        
    }



    /**
     * Single api to fetch content for entire page
     */
    function firstPageCall () {
        /**
         * Response: Featured, new, recommended, upcoming
         */
        UI.$b.addClass('loading');
        $.ajax({
            url: '/ajax/tv/home',
            type: 'POST',
            success: function (response) {
                if(response.status === true) {
                    tvPageData = response.response.episodes;
                    var html = template('tplTVPageWrapper', {page: 1, data: tvPageData});
                    UI.$b.append(html);
                    if(tvPageData.featured && tvPageData.featured.length > 1)
                        tvFeaturedSlider();
                } else {
                    console.log('tv error')
                }
                UI.$b.removeClass('loading');
            }
        });
    }


    function bindEvents () {
        // Only for first page call. See more sections
        UI.$b.on('click', '.tv-page-block .btn-section-more', function () {
            var type = $(this).data('type');
            if(!type) {
                return false;
            }
            showTVListPage(langs[type+'_videos'], type);
            return false;
        });

        // Play video inline for videoList
        UI.$b.on('click', '.list-tv-episodes .btn-play-video', function () {
            var $btn = $(this),
                $wrap = $btn.parents('.ep-preview').children('.left'),
                videoId = $btn.data('video-id'),
                topicId = $btn.data('topic-id');

            require(['Groups'], function (Groups) {
                Groups.TVTrackAndPlay({
                    topicId: topicId,
                    videoId: videoId,
                    autoplay: true,
                    playfullscreen: true,
                    sourcePage: 'tv'
                });
            });
            return false;
        });
    }

    function getYTIframe (videoId, autoplay) {
        if(!videoId) {
            return false;
        }
        autoplay = autoplay || 0;
        return '<iframe class="ytplayer" width="100%" src="https://www.youtube.com/embed/'+videoId+'?modestbranding=1&autoplay='+autoplay+'&showinfo=0" frameborder="0" allowfullscreen></iframe>';
    }

    /**
     * TV List page
     */
    function showTVListPage (pageName, type) {
        type = type || 'recommended';   // upcoming|recommended|new
        pageName = pageName || '';
        UI.noscroll();
        require(['DataList'], function(DataList) {
            var dataList = new DataList(),
                $elTVListPage = $('#TVListPageContainer');

            $elTVListPage.find('.sec-legend').text(pageName);
            var template = (type === 'upcoming') ? 'tplTVUpcomingList' : 'tplTVVideoList';

            require(['History'], function(History) {
                History.pushState({
                    popupId: 'TVListPageContainer',
                    url: '/tv/videos?type=' + type,
                    removeEl: false,
                    callback: function () {
                        UI.showBackButton(false);
                        if(window.history && Config.get('page.route') !== 'tv') {
                            window.history.replaceState({}, '', '/tv');
                        }
                    }
                });
            });
            $('#listTVUniversalContainer').html('');
            $elTVListPage.show();

            dataList.init({
                containerId: 'listTVUniversalContainer',
                template: template,
                useApi: true,
                autoload: true,
                api: '/ajax/tv/episodes',
                lazyLoad: true,
                elLazyButtonId: 'btnLoadMoreTVContent',
                rpp: 10,
                hasTopic: true,
                apiData: {
                    page: 1,
                    type: type
                },
                precessRenderResponse: function (response) {
                    return response && response.episodes ? response.episodes : null;
                }
            });
            UI.showBackButton(true);
        });
    }

    // Featured slider would be completely JS based
    function tvFeaturedSlider () {
        require(['glide'], function () {
            $('#tvFeaturedCarousel').glide({
                type: "carousel",
                keyboard: false
            });
        });
    }

    function renderVideoList (preset_data, wrapperID, type) {
        type = type || 'video'; // video, upcoming
        if(!preset_data) {
            return false;
        }
        var tpl = type === 'upcoming' ? 'tplUpcomingList' : 'tplVideoList';
        var html = template(tpl, {page: 1, data: preset_data});
        $('#'+wrapperID).html(html);
    }




    /**
     * 
     * Categories page
     * 
     */
    function CategoryPageCall () {
        /**
         * Response: Featured, new, recommended, upcoming
         */
        UI.$b.addClass('loading');
        $.ajax({
            url: '/ajax/tv/episodes/category',
            type: 'POST',
            success: function (response) {
                if(response.status === true) {
                    var categoryData = response.response;
                    var html = template('tplTVCategoryWrapper', {
                        page: 1,
                        data: categoryData,
                        modules: {
                            Config: Config
                        }
                    });
                    UI.$b.append(html);
                    if($(html).find('.itm-block[default]').length) {
                        var defaultIndex = $(html).find('.itm-block[default]').index();
                        setTimeout(function () {switchCategoryAccordian(defaultIndex)}, 700)
                        
                    }
                } else {
                    console.log('tv cat error')
                }
                UI.$b.removeClass('loading');
            }
        });

        // Events
        UI.$b.on('click', '#tvCategoryAccordian .itm-block .itm-heading', function () {
            var $btn = $(this),
                $parent = $btn.parent('.itm-block'),
                index = $parent.index();
                if(!$parent.is('.active')) {
                    switchCategoryAccordian(index);
                }
            return false;
        });
        // Show specific category list
        UI.$b.on('click', '#tvCategoryAccordian .itm-block .btn-section-more', function () {
            var $btn = $(this),
                catId = $btn.data('cat-id'),
                slug = $btn.data('slug'),
                pageName = $btn.data('page');
            showCategorizedPage(catId, slug, pageName);
            return false;
        });
    }
    function switchCategoryAccordian (index) {
        $('#tvCategoryAccordian .itm-block')
            .eq(index).addClass('active').children('.itm-container').slideDown()
            .parent('.itm-block').siblings('.itm-block').removeClass('active').children('.itm-container').slideUp();
    }

    function showCategorizedPage (catId, slug, pageName) {
        pageName = pageName || '';
        if(!catId) {
            return false;
        }
        UI.noscroll();
        require(['DataList'], function(DataList) {
            var dataList = new DataList(),
                $elTVCatPage = $('#TVCategorizedListContainer');

            var template = 'tplTVVideoList';

            require(['History'], function(History) {
                History.pushState({
                    popupId: 'TVCategorizedListContainer',
                    url: '/tv/categories?cat='+slug,
                    removeEl: false,
                    callback: function () {
                        UI.showBackButton(false);
                    }
                });
            });
            $('#listTVUniversalContainer').html('');
            if(pageName) {
                $elTVCatPage.find('.sec-legend').html(pageName).show();
            } else {
                $elTVCatPage.find('.sec-legend').hide();
            }
            $elTVCatPage.show();

            dataList.init({
                containerId: 'listTVUniversalContainer',
                template: template,
                useApi: true,
                autoload: true,
                api: '/ajax/tv/episodes/category',
                lazyLoad: true,
                elLazyButtonId: 'btnLoadMoreTVContent',
                rpp: 10,
                apiData: {
                    page: 1,
                    episodeCategoryId: catId
                },
                precessRenderResponse: function (response) {
                    return response.length && response[0].episodes ? response[0].episodes : null;
                }
            });
            UI.showBackButton(true);
        });
    }


    /**
     * Experts page
     */
    function ExpertsPage () {
        require(['DataList'], function(DataList) {
            var dataList = new DataList();

            dataList.init({
                containerId: 'listExpertsPage',
                template: 'tplExpertsList',
                useApi: true,
                autoload: true,
                api: '/ajax/user/experts',
                lazyLoad: true,
                elLazyButtonId: 'btnSeeMoreExpertsPage',
                rpp: 15,
                apiData: {
                    page: 1
                },
                precessRenderResponse: function (response) {
                    return response && response.experts ? response.experts : null;
                }
            });
        });
    }

    init();

});


/*
var dataList = new DataList();
dataList.init({
    containerId: 'amaTvContainer',
    template: 'tplAmaList',
    useApi: true,
    autoload: true,
    api: '/ajax/ama/list',
    lazyLoad: true,
    elLazyButtonId: 'loadMoreAma',
    apiData: {
        page: 1
    },
    langs: langs
});
*/;
